export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10354.a7880764.jpg";